import clsx from "clsx"
import { ComponentPropsWithoutRef, FC } from "react"
import { CurrencyIcon } from "@/helpers/currencyIcon"
import { numberSpaceFixer } from "@/helpers/numberSpaceFixer"
import { ICurrency } from "@/store/apis/balanceAPI"
import { useGetLabrUserBalanceQuery } from "@/store/apis/userAPI"
import styles from "@/ui/BalancePill/BalancePill.module.scss"
import { Container } from "@/ui/Container"

interface ILabrBalancePill extends ComponentPropsWithoutRef<"div"> {
  currency: ICurrency
}

export const LabrBalancePill: FC<ILabrBalancePill> = ({
  currency,
  className,
  ...props
}) => {
  const { data: balance } = useGetLabrUserBalanceQuery()

  const Icon = CurrencyIcon[currency]

  return (
    <Container
      className={clsx(styles.BalancePill, styles[currency], className)}
      {...props}
    >
      <div className={clsx(styles.BalancePill_icon)}>
        <Icon />
      </div>
      <div className={clsx(styles.BalancePill_value)}>
        {numberSpaceFixer(balance?.[currency], 2)}
      </div>
    </Container>
  )
}
